import React, { useMemo } from 'react';
import { IItemForGetShortInfo } from 'types';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import style from './Info.module.scss';

interface IProps {
	customerName: string;
	inclusive: Nullable<number>;
	fetchedRestaurants: IItemForGetShortInfo[];
	IDSelectedRestaurantOnRestPropsPage: Nullable<string>;
	forceDisable: boolean;
}

export const Info: React.FC<IProps> = React.memo(
	({ customerName, inclusive, fetchedRestaurants, IDSelectedRestaurantOnRestPropsPage, forceDisable }) => {
		const { t } = useTranslation('form');

		const restaurantName = useMemo(() => {
			return (
				fetchedRestaurants.find((restaurant) => restaurant.id === IDSelectedRestaurantOnRestPropsPage)?.name ||
				'-'
			);
		}, [fetchedRestaurants, IDSelectedRestaurantOnRestPropsPage]);

		const inclusiveValue = inclusive !== null ? String(inclusive) : '-';

		return (
			<div className={style.container}>
				<div className={style.item}>
					<FullInfoField
						containerClassName={style.input}
						label="customerLabel"
						value={customerName}
						useInForm={true}
					/>
					<FullInfoField
						containerClassName={style.input}
						label="restaurantLabel"
						value={restaurantName}
						useInForm={true}
					/>
				</div>
				<div className={style.item}>
					<FullInfoField
						containerClassName={style.input}
						label="inclusiveLabel"
						value={inclusiveValue}
						useInForm={true}
					/>
				</div>
				<div className={style.item}>
					<FullInfoField
						containerClassName={style.input}
						label="isForceDisabledLabel"
						value={forceDisable ? String(t('yes')) : String(t('no'))}
						prefixIcon="asCheckbox"
						prefixIconName={forceDisable ? 'checkMark' : 'crossMark'}
						prefixIconIsChecked={forceDisable}
						useInForm={true}
					/>
				</div>
			</div>
		);
	},
);
